import { IconProps } from ".";
import Icon from "./assets/circle_pentool.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24CirclePentool(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
